import { ErrorMessage } from "@hookform/error-message";
import { SimpleErrorMessage } from "common/components/SimpleErrorMessage";
import React from "react";

interface Props {
  name: string;
}

export const FieldError: React.FC<React.PropsWithChildren<Props>> = (props) => (
  <ErrorMessage
    name={props.name}
    render={({ message }) => <SimpleErrorMessage>{message}</SimpleErrorMessage>}
  />
);
